/*
 * @Author: hfxie
 * @Date: 2022-09-12 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-04-28 10:29:11
 * @Description: 常量:交互自定义事件接口·调用的方法名
 */

const DEMO = "gtRefreshData"; // 示例出去的常量方法名

const CUSTOM_INIT = "custom_init"; // 初始化·主动发起数据加载
const SELECT_ROW = "singleClick"; // 单击行
const UPDATE_TREE_WIDTH = "updateTreeWidth"; // 设置树宽
const UPDATE_HEADITEM_WIDTH = "updateHeadItemWidth"; // 设置单元格宽



const OutConst = {
  DEMO,

  CUSTOM_INIT,
  SELECT_ROW,
  UPDATE_TREE_WIDTH,
  UPDATE_HEADITEM_WIDTH,

};

export default OutConst;
